import {
  Alert,
  ContentLayout,
  Header,
} from '@cloudscape-design/components';
import {
  getPLCUrl,
} from 'features/plc/contracts/machines';
import { TEST_STAND_GROUPS, TS_PATHS } from 'features/plc/contracts/testStand.schema';
import HMIHandleProvider from 'features/plc/providers/HMIHandleProvider';
import React from 'react';

import { TestStandProvider } from './providers/TestStandProvider';
import TestStandRouter from './router';

const PRESS_ID = 'test1';

export default function TestStandPage() {
  const plcUrl = getPLCUrl(PRESS_ID);
  if (!plcUrl && process.env.REACT_APP_ENV === 'production') {
    return (
      <ContentLayout header={<Header variant="h1">Test Stand</Header>}>
        <Alert type="error" header="Not configured">
          PLC URL for Test Stand is not set.
        </Alert>
      </ContentLayout>
    );
  }

  return (
    <HMIHandleProvider
      pressId={PRESS_ID}
      plcUrl={plcUrl}
      groupsMap={TEST_STAND_GROUPS}
      debugPaths={TS_PATHS}
      test={process.env.REACT_APP_ENV !== 'production'}
    >
      <TestStandProvider>
        <TestStandRouter />
      </TestStandProvider>
    </HMIHandleProvider>
  );
}
